// Logout owns credential/account cleanup. Keep legacy local-storage isolation
// until a live account-switch audit justifies a narrower allowlist. Updates and
// maintenance must never call this function. Navigation/authentication can still
// proceed if storage is denied by the browser.
export function clearLogoutStorage({ local, session }) {
  try {
    session.removeItem('department');
    session.removeItem('roleChoice');
  } catch (_) {}
  try {
    const seasonKeys = [];
    for (let i = 0; i < session.length; i++) {
      const key = session.key(i);
      if (key && key.startsWith('selectedSeason_')) seasonKeys.push(key);
    }
    seasonKeys.forEach((key) => session.removeItem(key));
  } catch (_) {}
  try {
    local.clear();
  } catch (_) {}
}
